import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import {
  StyledDialog,
  Content,
  CloseIconStyled,
  CloseBox,
  Icon,
  BoxButton,
  ClientDataBox,
  TextOpacity,
} from './styles';
import { useTheme } from '@mui/material/styles';
import alertWarning from 'assets/icons/alertWarning.svg';
import { IUnsuccessfulPaymentModal } from 'v3/shared/components/Modal/UnsuccessfulPaymentModal/types';
import { useStoreSelector } from 'v3/data/store';
import { formatCPF } from 'utils/formatters';
import { BodyMediumRegular } from 'v3/shared/typography/BodyMedium';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { TitleSmall } from 'v3/shared/typography/TitleSmall';

export const UnsuccessfulPaymentModal: React.FC<IUnsuccessfulPaymentModal> = ({ open, setOpenModal }) => {
  const theme = useTheme();
  const { person } = useStoreSelector((store) => store.person);

  return (
    <StyledDialog open={open}>
      <CloseBox>
        <CloseIconStyled onClick={() => setOpenModal()} aria-label="Fechar modal" />
      </CloseBox>
      <Content>
        <Icon src={alertWarning} alt="Check" />
        <BodyMediumRegular color={theme.palette.common.white} align='center'>
          O pagamento não foi realizado por problemas técnicos.
        </BodyMediumRegular>
        <BodySmallRegular color={theme.palette.common.white} align='center'>
          Nenhuma quantia foi debitada da conta dessa tentativa.
        </BodySmallRegular>
        <ClientDataBox>
          <TextOpacity>
            <TitleSmall color={theme.palette.common.white} align='center'>
              CPF do cliente
            </TitleSmall>
          </TextOpacity>
          <BodySmallRegular color={theme.palette.common.white} align='center'>
            {formatCPF(person.cpf)}
          </BodySmallRegular>
          <TextOpacity>
            <TitleSmall color={theme.palette.common.white} align='center' marginTop={'0.75rem'}>
              Nome do cliente
            </TitleSmall>
          </TextOpacity>
          <BodySmallRegular color={theme.palette.common.white} align='center'>
            {person.fullName}
          </BodySmallRegular>
        </ClientDataBox>
        <BoxButton>
          <FlexButton
            text="Voltar a página inicial"
            size="small"
            handleClick={() => setOpenModal()}
          />
        </BoxButton>
      </Content>
    </StyledDialog>
  );
};